module.exports = __webpack_public_path__ + "img/MemberCard3.a16fad7a.jpg";